import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATE_PROFILE_ROUTE_NAME } from '@modules/affiliates-approved/submodules/affiliate-profile/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  AFFILIATE_PROFILE_CONTACTS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedProfileContactsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_PROFILE_ROUTE_NAME, {
      name: AFFILIATE_PROFILE_CONTACTS_ROUTE_NAME,
      path: 'contacts',
      component: () => import('./pages/ProfileContactsPage/ProfileContactsPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS, getTranslationKeys);
  }
}
